import React, { useReducer } from 'react';
import {
 BrowserRouter as Router,
 Routes,
 Route,
 Navigate
} from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PrivateRoute from './layouts/PrivateRoute';
import { RootContext } from './context/RootContext';
import rootReducer from './reducers/rootReducer';
import SideBar from './components/sidebar';
import Userhome from './components/vizionAI/sidebar/sidebarVA'
import Login from './components/Login/login';
import LoginConfiguration from './components/Login/loginconfiguration';
import DemoDashboard from './components/modaltraining/dragdrop/demodashboard';
import SelectCamera from './components/cameracategory/selectcamera';
import CameraSetup from './components/cameraconnectinformation';
import CreateProject from './components/modaltraining/createproject';
import HomeLayout from './components/home/home';
import AddCamera from './components/vizionAI/camera/addcamera';
import ViewCamera from './components/vizionAI/camera/viewcamera';
import PublicRoute from './layouts/PublicRoute';
import SelectModal from './components/modaltraining/selectmodal';
import PreDataFlow from './components/pretrainedmodal/predataflow';
import DataFlowPre from './components/pretrainedmodal/dataflowpre';
import SelectProject from './components/modaltraining/dragdrop/selectproject';
import Credits from './components/credits';
import LandingPage from './components/Login/landingPage';
import Register from './components/Login/register';
import SubscriptionPage from './components/subscription';
import ScrollToTop from './utils/ScrollToTop';
import SectorUseCases from './components/home/sectorUsecases';
import DashboardBuilder from './components/modaltraining/dragdrop/dragdrop'
import UserPage from './components/vizionAI/sidebar/userPage';
import GrowelHome from './components/growel/growelhome';
import TableSpaceHome from './components/tablespace/layout';
import PrestigeHome from './components/prestige/layout';
import EmpireHome from './components/empire/layout';
import TanseeqHome from './components/tanseeq/layout';
import EmpireAddCamera from './components/empire/empireAddCamera';
import EmpireLiveView from './components/empire/EmpireLiveView';
import EmpireBuildDashboard from './components/empire/empireBuildDashboard';

export default function App() {
  const initalState = {
    auth: {
      isLoggedIn: false,
      user: null
    },
    admin: null,
  };

 const [state, dispatch] = useReducer(rootReducer(initalState), initalState);


 return (
   <RootContext.Provider value={{ ...state, dispatch }}>
     <Router>
      <ScrollToTop />
     {/* <MainWrapper> */}
       <Routes>
        {<Route
          path="/home"
          element={<PrivateRoute><HomeLayout /></PrivateRoute>}
        />}
        <Route
            path="/sidebar/*"
            element={
              <PrivateRoute>
                <SideBar path='/sidebar'/>
              </PrivateRoute>
            }
          />
        <Route path='/demodashboard' element={<PrivateRoute><DemoDashboard /></PrivateRoute>} />
        <Route path="/userhome/*" element={<PrivateRoute><Userhome path='/userhome' /></PrivateRoute>} />
        <Route path="/user/*" element={<PrivateRoute><UserPage path='/user' /></PrivateRoute>} />
        {/* <Route path="/sidebar" element={<Sider />} /> */}
        <Route path="/selectcamera" element={<PrivateRoute><SelectCamera /></PrivateRoute>} />
        <Route path='/landing-page' element={<LandingPage/>}/>
        <Route path="/login" element={<Login />} />
        <Route path="/loginconfiguration" element={<LoginConfiguration />} />
        <Route path="/register" element={<Register/>} />
        <Route path="/cameraconnectinformation" element={<PrivateRoute><CameraSetup /></PrivateRoute>} />
        <Route path="/create-project" element={<PrivateRoute><CreateProject /></PrivateRoute>} />
        {/* <Route path="/dashboard-setting" element={<PrivateRoute><DashboardBuilder /></PrivateRoute>} /> */}
        <Route path="/add-camera" element={<PrivateRoute><AddCamera /></PrivateRoute>} />
        <Route path='/view-camera' element={<PrivateRoute><ViewCamera /></PrivateRoute>} />
        <Route path="/selectmodel" element={<PrivateRoute><SelectModal /></PrivateRoute>} />
        <Route path="/preDataFlow" element={<PrivateRoute><PreDataFlow /></PrivateRoute>} />
        <Route path='/dataFlowPre' element={<PrivateRoute><DataFlowPre /></PrivateRoute>} />
        <Route path="/select-project" element={<PrivateRoute><SelectProject /></PrivateRoute>} />
        <Route path="/credits" element={<PrivateRoute><Credits /></PrivateRoute>} />
        <Route path="/subscription" element={<PrivateRoute><SubscriptionPage /></PrivateRoute>} />
        <Route path='/dashboard-builder' element={<PrivateRoute><DashboardBuilder /></PrivateRoute>} />
        <Route path="/usecases/:sector" element={<PrivateRoute><SectorUseCases /></PrivateRoute>} />
        <Route path="/" element={<Navigate to="/landing-page" replace />} />
        <Route
          path="/"
          element={
            <PublicRoute>
              <LandingPage />
            </PublicRoute>
          }
        />
          <Route path="/growelhome/*" element={<PrivateRoute><GrowelHome /></PrivateRoute>} />
          <Route path="/tablespacehome/*" element={<PrivateRoute><TableSpaceHome /></PrivateRoute>} />
          <Route path='/prestigehome/*' element={<PrivateRoute><PrestigeHome /></PrivateRoute>} />
          <Route path='/empirehome/*' element={<PrivateRoute><EmpireHome /></PrivateRoute>} />
          <Route path='/tanseeqhome/*' element={<PrivateRoute><TanseeqHome /></PrivateRoute>} />
          <Route
            path="/empire/add-camera"
            element={<EmpireAddCamera />}
          />

          <Route
            path="/empire/live-view"
            element={<EmpireLiveView />}
          />

          <Route
            path="/empire/build-dashboard"
            element={<EmpireBuildDashboard />}
          />
          
       </Routes>
     {/* </MainWrapper> */}
     </Router>
   </RootContext.Provider>
 );
}